export enum DistributorRole {
  Gallo = "distributor-gallo",
  DistributorAdmin = "distributor-admin",
  DistributorOrderer = "distributor-orderer",
}

export type UserRole =
  | "field1"
  | "field2"
  | "purchaser"
  | "select-purchaser"
  | "compliance"
  | "central"
  | "super"
  | "supplier"
  | "planning-tool-supplier"
  | "freight-forwarder"
  | "read-only"
  | "creative"
  | DistributorRole.DistributorAdmin
  | DistributorRole.DistributorOrderer
  | DistributorRole.Gallo;
